import { defineStore } from "pinia";
import {
  writeNewAddress,
  getAddresses,
  choseAddress,
  getSelectedAddressByUser,
  get_user_data,
  updateUserName,
} from "@/config/use_cases/users";
import { getDefault } from "@/config/use_cases/home";
import { Login_Google, Logout } from "@/config/use_cases/login";
import { getSimpleLocacion } from "@/components/helpers/location";

export const useUserStore = defineStore("user", {
  state: () => ({
    addresses: [] as any[],
    selected_address: JSON.parse(
      localStorage.getItem("selected_address") || "{}",
    ) as Record<string, any>,
    user_data: JSON.parse(
      localStorage.getItem("user_data") || '{"name": "Usuario Invitado"}',
    ) as Record<string, any>,
  }),
  getters: {
    isLoggedUser: () => localStorage.getItem("user_id") || "",
    getAddress: (state) => state.selected_address || {},
    getAddressesId: (state) => state.selected_address.id || "",
    getUserData: (state) => state.user_data,
    getUserName: (state) => state.user_data.name || "",
    getCountryId: (state) => state.selected_address.country_id || "",
    getUserEmail: (state) => state.user_data.email || "",
  },
  actions: {
    async login() {
      const data: any = await Login_Google();
      localStorage.clear();
      if (data) {
        localStorage.setItem("user_id", data.id);
        this.user_data = data;
        console.log(data)
        localStorage.setItem("user_data", JSON.stringify(data));
        await this.loadUserData();
      }

      return data;
    },

    async logout_session() {
      const result = await Logout();
        
      if (result) {
        this.selected_address = {};
        localStorage.clear();
        // this.user_data = { name: "Usuario Invitado" };
        // localStorage.clear();
      }
    },
    async loadLocal(lat: number, lng: number) {
      const selected_address = {
        address: "",
        city: {
          name: "GPS",
          id: "Local",
        },
        created_at: "",
        description: "Ubicacion obtenida desde el dispositivo",
        g: {
          geohash: "",
          geopoint: [lat, lng],
        },
        id: "default_location",
        mobile: "",
        municipality_id: "Local",
        name: "Default Location",
        state_id: "",
        country_id: "MX",
        status: "active",
        updated_at: "",
      };
      const user_data = this.getUserData || { name: "Usuario Invitado" };
      this.selected_address = selected_address;
      localStorage.setItem("user_data", JSON.stringify(user_data));
      localStorage.setItem(
        "selected_address",
        JSON.stringify(selected_address),
      );
    },
    async loadDefaultInformation() {
      let location = await getSimpleLocacion();
      if (!location.error) {
        await this.loadLocal(location.coords.lat, location.coords.lng);
        return location;
      }
      if (this.selected_address.id === "default_location") {
        return location;
      }
      const data: any = await getDefault();
      if (!this.isLoggedUser) {
        localStorage.clear();
      }

      const selected_address = {
        address: "",
        city: {
          name: data.city_name,
          id: data.city_id,
        },
        created_at: "",
        description: "",
        g: data.g,
        id: "default_location",
        mobile: "",
        municipality_id: data.municipality_id,
        name: "Default Location",
        state_id: data.state_id,
        country_id: data.country_id,
        status: "active",
        updated_at: "",
      };
      localStorage.setItem(
        "selected_address",
        JSON.stringify(selected_address),
      );
      this.selected_address = selected_address;
      localStorage.setItem(
        "user_data",
        JSON.stringify({ name: "Usuario Invitado" }),
      );
      return location;
    },
    async loadUserData() {
      let success = false;
      const location_id = this.selected_address.id;
      if (location_id && location_id !== "default_location") {
        return true;
      }
      try {
        const user_id = localStorage.getItem("user_id");
        if (!user_id) {
          throw new Error("User ID not found in session storage");
        }

        let user_data = this.user_data;
        if (!user_data.id) {
          const user_data = await get_user_data(user_id);
          if (!user_data) {
            localStorage.clear();
            throw new Error("User data not found");
          }
          this.user_data = user_data;
        }
        localStorage.setItem("user_data", JSON.stringify(user_data));
        const { selected_location } = user_data;
        if (selected_location) {
          const selected_address = await getSelectedAddressByUser(
            user_id,
            selected_location.current_location_id,
          );
          if (selected_address) {
            this.selected_address = selected_address;
            localStorage.setItem(
              "selected_address",
              JSON.stringify(selected_address),
            );
            success = true;
          }
        } else {
          await this.loadDefaultInformation();
          success = true;
        }
      } catch (error) {
        console.error("Error loading user data", error);
      }

      return success;
    },
    async saveAddress(address: any) {
      const user_id = localStorage.getItem("user_id");
      if (!user_id) {
        throw new Error("User ID not found in session storage");
      }
      const response = await writeNewAddress(user_id, address);
      if (address.id) {
        const new_addresses = this.addresses.filter(
          (element) => element.id !== address.id,
        );
        this.addresses = [...new_addresses, response];
      } else {
        this.addresses.push(response);
      }
      return response;
    },
    async getAddresses() {
      const user_id = localStorage.getItem("user_id");
      if (!user_id) {
        throw new Error("User ID not found in session storage");
      }
      let response = this.addresses;
      if (response.length < 1) {
        const data = await getAddresses(user_id);
        this.addresses = data;
        response = data;
      }
      return response;
    },
    async selectAddress(address: any) {
      const user_id = localStorage.getItem("user_id");
      if (!user_id) {
        throw new Error("User ID not found in session storage");
      }
      await choseAddress(user_id, address);
      this.selected_address = address;
      localStorage.setItem("selected_address", JSON.stringify(address));
    },
    async updateUser(user_name: string) {
      const user_id = localStorage.getItem("user_id");
      if (!user_id) {
        return false;
      }
      await updateUserName(user_id || "", user_name);
      this.user_data.name = user_name;
      localStorage.setItem("user_data", JSON.stringify(this.user_data));
      return true;
    },
  },
});
